import { render, staticRenderFns } from "./TakeawayOrderByApp.vue?vue&type=template&id=67960542&scoped=true&"
import script from "./TakeawayOrderByApp.vue?vue&type=script&lang=js&"
export * from "./TakeawayOrderByApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67960542",
  null
  
)

export default component.exports